import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=495a4e6c&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a4e6c",
  null
  
)

export default component.exports